<template>
  <w-sliding-popup ref="slidingPopup" title="컬럼 설정" top="50px" width="400px" @close="close">
    <div slot="content">
      <div class="mr-b25">
        <div class="title-h4 title-bar">순서정렬</div>
        <el-row v-show="selectedConfigTemplate.length > 0" style="height: 345px;">
          <el-scrollbar>
            <draggable v-model="selectedConfigTemplate" class="list-drag-box" element="ul" @start="isDraggable=true" @end="isDraggable=false">
               <li v-for="element in selectedConfigTemplate" :key="element.columnId">
                 <div class="label">{{element.columnName}}</div>
               </li>
            </draggable>
          </el-scrollbar>
        </el-row>
        <el-row v-show="selectedConfigTemplate.length < 1" style="height: 345px;" type="flex" justify="center" align="middle">
          <div>
            설정한 컬럼이 없습니다.
          </div>
        </el-row>
      </div>
      <div>
        <div class="title-h4">구성 정보 선택</div>
        <el-row class="vertical-center-box mr-b5" type="flex" justify="space-between">
          <em style="font-size:12px;">최대 20개까지 선택이 가능합니다.</em>
          <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
        </el-row>
        <el-table-wrapper style="height: 350px;" :columns="templateConfigTableColumns" :column-default="columnDefault" :show-search-tool="showSearchTool"
          fit-height border :data="templateConfigTableData" :pagination="false" :show-custom-header="true">
          <template slot-scope="scope" slot="checkFlag">
              <el-checkbox v-model="scope.row.checkFlag" @change="onChangeConfigTemplate(scope.row, ...arguments)" :true-label="1" :false-label="0"></el-checkbox>
          </template>
        </el-table-wrapper>
      </div>
    </div>
    <div slot="footer">
      <el-button type="solid" size="large" @click="onSaveButtonClick">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { columnDefault } from '@/constants/table';
import { cloneDeep, forEach, isUndefined } from 'lodash';
import draggable from 'vuedraggable';
import netdeviceInfoAPI from '@/api/config/netdevice/netdevice-info';
import MsgUtil from '@/utils/message';

export default {
  name: 'WDeviceListColumnSetPopup',
  components: {
    draggable,
  },
  data() {
    return {
      templateConfigTableData: [],
      columnDefault,
      showSearchTool: false,
      isSelected: [],
      isDraggable: false,
      selectedConfigTemplate: [],
      selectedConfigTemplateOrigin: [],
      templateConfigTableColumns: [
        { label: '선택', width: 50, scopedSlot: 'checkFlag' },
        { prop: 'columnName', label: '구성 정보', sortable: true, searchable: true },
      ],
    };
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      this.loadData();
    },
    close() {
      this.$refs.slidingPopup.visible = false;
      // init
      this.selectedConfigTemplate = [];
      this.isSelected = [];
    },
    /**
     * 해당 사용자가 선택한 확장 컬럼 및 구성 OID 템플릿을 조회한다.
     * @author Song
     */
    loadData() {
      // 구성 OID 템플릿 리스트 조회
      netdeviceInfoAPI.getConfigTemplateList().then((res) => {
        if (res.data.success) {
          this.templateConfigTableData = cloneDeep(res.data.data);
          this.selectedConfigTemplate = res.data.data.filter((value) => value.checkFlag === 1);
          this.selectedConfigTemplateOrigin = cloneDeep(this.selectedConfigTemplate);

          // 선택한 구성 컬럼 값을 orderbyIndex에 따라 정렬한다.
          this.selectedConfigTemplate.sort((pre, next) => pre.orderbyIndex - next.orderbyIndex);
        }
      });
    },
    onSaveButtonClick() {
      // 순서정렬
      const viewDatagridColumnSet = [];
      forEach(this.selectedConfigTemplate, (item, index) => {
        item.orderbyIndex = index + 1;
        viewDatagridColumnSet.push(item);
      });
      // parameter 설정
      const params = {
        viewDatagridColumnSet,
        delTemplate: [],
        modiTemplate: [],
        insertTemplate: [],
      };
      forEach(this.selectedConfigTemplateOrigin, (item) => {
        const resultList = this.selectedConfigTemplate.find((target) => target.columnId === item.columnId);
        if (isUndefined(resultList)) {
          delete item.checkFlag;
          params.delTemplate.push(item);
        } else {
          delete resultList.checkFlag;
          params.modiTemplate.push(resultList);
        }
      });
      forEach(this.selectedConfigTemplate, (item) => {
        const resultList = this.selectedConfigTemplateOrigin.find((target) => target.columnId === item.columnId);
        if (isUndefined(resultList)) {
          delete item.checkFlag;
          params.insertTemplate.push(item);
        }
      });
      // API
      netdeviceInfoAPI.setConfigTemplateColumn(params).then((res) => {
        if (res.data.success) {
          this.$refs.slidingPopup.close();
          this.$emit('reload-data', true);
        }
      });
    },
    /**
     * 구성 정보 테이블 체크 클릭 이벤트
     * @author Song
     */
    onChangeConfigTemplate(row, newValue) {
      const count = this.selectedConfigTemplate.length;
      if (newValue === 1 && count === 20) {
        this.$message(MsgUtil.getCustomResultMsgData('최대 20개까지 선택이 가능합니다.'));
        this.$nextTick(() => {
          row.checkFlag = 0;
        });
      } else if (newValue === 0) {
        // 삭제
        const targetIndex = this.selectedConfigTemplate.findIndex((item) => item.columnId === row.columnId);
        this.selectedConfigTemplate.splice(targetIndex, 1);
      } else {
        // 추가
        this.selectedConfigTemplate.push(row);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/config/group/netdevice/components/popup/DeviceListColumnSetPopup.vue